<template>
    <section class="gmp-section gmp-mb-l">
        <div class="secondary-hero">
            <div class="secondary-hero__frame">
                <div class="secondary-hero__background">
                    <div class="gmp-banner">
                        <picture>
                            <img src="@/assets/img/goods_dis.png" alt=""  class="gmp-no-grab secondary-hero__image">
                        </picture>
                    </div>
                </div>

                <div class="secondary-hero__content">
                    <div class="h-c-page">
                        <div class="h-c-grid">
                            <div class="h-c-grid__col h-c-grid__col--8 h-c-grid__col-l--6 h-c-grid__col-l--offset-1 h-c-grid__col-xl--5">
                                <div class="secondary-hero__text-box">
                                    <h1 class="h-c-headline secondary-hero__headline h-has-bottom-margin">
                                        精准供应
                                    </h1>
                                    <h2 class="h-c-description secondary-hero__description">
                                        <p>
                                            深入了解该商品的市场需求、生产周期、质量控制等各个环节，从而提供更高质量的产品
                                        </p>
                                    </h2>

<!--                                    <a href="/" class="h-c-button h-c-button&#45;&#45;primary">-->
<!--                                        Start for free-->
<!--                                    </a>-->

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    </section>
</template>

<script>
    export default {
        name: "Goods_scondHero",
        data(){
          return{
          }
        },
        methods:{

        }
    }
</script>

<style lang="less">



</style>